export enum EJumpPadHologramBuildStep {
  JPHBS_PlacementAndRotation,
  JPHBS_AdjustAngle,
}
